export const environment = {
  production: false, 
  envName: 'dev',
  backendUrl: 'https://simserver-dev.quantified.ai',
  adminPortal: 'https://simadmin-dev.quantified.ai',
  googleAnalyticsTrackingId: 'G-7SQ6692CPX',
  amplitudeApiKey: 'b170209d11236db82b780a5264da63a5',
  hotjarSiteId: 5153546,
  splitIO: 'k8bm8r2svd01p9qm81fjvc8blp351i5k0bpq',
  helpscoutBeaconId: 'b55d6ec3-6f47-4a5b-84c6-1a26c30878e5',
  // TODO: replace with EU dev env URL once available — using EU prod temporarily for testing
  alternateRegionLoginUrl: 'https://sim.eu.quantified.ai/login',
  alternateRegionName: 'EU',
  assemblyAiStreamingUrl: 'wss://streaming.assemblyai.com/v3/ws',
};